<template>
  <div>
    <home-section
      id="home-section"
      currentPage="home"
      :isWebView="IsWebView"
    >
    </home-section>
    <download-section v-if="!IsWebView"></download-section>
    <about-section v-if="!IsWebView"></about-section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { HomeSection, DownloadSection, AboutSection } from "./components";
import { IsWebView } from "@/utilities/helper";
import SmartBanner from "@/plugins/smart-app-banner/index";
export default {
  name: "home",
  bodyClass: "home-page",
  components: {
    HomeSection,
    DownloadSection,
    AboutSection,
  },
  computed: {
    ...mapGetters('locationStore',['getStoreLinks']),
    IsWebView(){
      return IsWebView()
    }
  },
  methods: {
    initSmartAppBanner() {
      if (!this.getStoreLinks) return;
      new SmartBanner({
        daysHidden: 14, // days to hide banner after close button is clicked (defaults to 15)
        daysReminder: 1, // days to hide banner after "OPEN" button is clicked (defaults to 90)
        title: this.business ? this.business.name : "What The Fork",
        author: "@WhatTheFork",
        button: "Open",
        store: {
          ios: "On the App Store",
          android: "In Google Play",
        },
        price: {
          ios: "FREE",
          android: "FREE",
        },
        appStoreLanguage: "gb",
        // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
        icon: this.business ? this.business.logo : null, // full path to icon image if not using website icon image
        isNative: IsWebView(),
        iosAppId: this.getStoreLinks.appStore,
        androidAppId: this.getStoreLinks.playStore,
      });
    },
  },
  mounted() {
    this.refreshLocationData();
  },
  created() {
    this.initSmartAppBanner();
  },
};
</script>

